import axios from 'axios';

const baseUrl = '/rastreabilidade/emprestimo';

export default {
    async uploadSpreadsheet(file, idEmpresaCedente) {
        const formData = new FormData();
        formData.append('idEmpresaCedente', idEmpresaCedente);
        formData.append('file', file);
        const url = process.env.VUE_APP_HTTP_PATH + baseUrl + '/inserir-lote';

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
};
